import axios from "axios";
import { API_LINK } from "../constants/api";

const api = axios.create({
  // __prod__
  baseURL: `${API_LINK}api`,
});
axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
export default api;
